import React from 'react';
import {FormGroup, ControlLabel, HelpBlock, FormControl} from 'react-bootstrap';

function FieldGroup({id, label, help, ...props}) {
    return (
        <FormGroup controlId={id}>
            <ControlLabel>{label}</ControlLabel>
            <FormControl {...props}/>
            {help && <HelpBlock>{help}</HelpBlock>}
        </FormGroup>
    );
}

export default FieldGroup;


// WEBPACK FOOTER //
// ./src/camposTexto/FieldGroup.js